import * as types from './types';
import { loading } from 'State/actions';
import { createToast, toastType } from 'Common/ToastHelper';

export const getVerificationReport = (sitesCount, type, fiscalYear) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.VERIFICATION_REPORT_FETCHING, true));

    try {
      await MPWWebApi.getGeneric(`ControlInfo/SiteCount/${sitesCount}`);
      dispatch(getInitialData());
      const response = await MPWWebApi.postGenericInsertUpdate(
        `Reports/VerificationReport`,
        {
          Type: type,
          FiscalYear: fiscalYear,
        }
      );
      dispatch({
        type: types.VERIFICATION_REPORT_GET_REPORT,
        payload: response.data.Data ? response.data.Data : 'No Data',
      });
    } catch (error) {
      dispatch({
        type: types.VERIFICATION_REPORT_FETCH_ERROR,
        payload: error.response,
      });
      createToast(toastType.error, 'Error', 'Failed to generate report.');
    }

    dispatch(loading(types.VERIFICATION_REPORT_FETCHING, false));
  };
};

export const clearReport = () => {
  return {
    type: types.VERIFICATION_REPORT_GET_REPORT,
    payload: null,
  };
};

export const getStatusByFiscalYear = fiscalYear => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.VERIFICATION_REPORT_FETCHING, true));
    try {
      let response = await MPWWebApi.getGeneric(
        `ControlInfo/VerificationStatus/${fiscalYear}`
      );
      dispatch({
        type: types.VERIFICATION_REPORT_GET_STATUS,
        payload: response.data.Data,
      });
    } catch (error) {
      dispatch({
        type: types.VERIFICATION_REPORT_FETCH_ERROR,
        payload: error.response,
      });
    }

    dispatch(loading(types.VERIFICATION_REPORT_FETCHING, false));
  };
};

export const getInitialData = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.VERIFICATION_REPORT_FETCHING, true));

    try {
      let response = await MPWWebApi.getGeneric('ControlInfo/FiscalYears');
      dispatch({
        type: types.VERIFICATION_REPORT_GET_FISCAL_YEARS,
        payload: response.data.Data,
      });

      dispatch(getVerificationCollection(response.data.Data[0]));

      response = await MPWWebApi.getGeneric('ControlInfo/SiteCount');
      dispatch({
        type: types.VERIFICATION_REPORT_GET_SITE_COUNT,
        payload: response.data.Data,
      });
    } catch (error) {
      dispatch({
        type: types.VERIFICATION_REPORT_FETCH_ERROR,
        payload: error.response,
      });
    }

    dispatch(loading(types.VERIFICATION_REPORT_FETCHING, false));
  };
};

export const getVerificationCollection = fiscalYear => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.VERIFICATION_REPORT_FETCHING, true));

    try {
      const response = await MPWWebApi.getGeneric(
        `Reports/GetVerificationCollection/${fiscalYear}`
      );
      dispatch({
        type: types.VERIFICATION_REPORT_GET_VERIFICATION_COLLECTION,
        payload: response.data.Data,
      });
    } catch (error) {
      dispatch({
        type: types.VERIFICATION_REPORT_FETCH_ERROR,
        payload: error.response,
      });
      createToast(
        toastType.error,
        'Error',
        'Failed to get verification collection data.'
      );
    }

    dispatch(loading(types.VERIFICATION_REPORT_FETCHING, false));
  };
};

export const writeVerificationCollection = model => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.VERIFICATION_REPORT_FETCHING, true));

    try {
      await MPWWebApi.postGenericInsertUpdate(
        `Reports/WriteVerificationCollection`,
        model
      );
    } catch (error) {
      dispatch({
        type: types.VERIFICATION_REPORT_FETCH_ERROR,
        payload: error.response,
      });
      createToast(
        toastType.error,
        'Error',
        'Failed to save verification collection data.'
      );
    }

    dispatch(loading(types.VERIFICATION_REPORT_FETCHING, false));
  };
};



// WEBPACK FOOTER //
// ./src/pages/verificationreport/state/verificationreport/actions.js